import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  &:not(:first-child) {
    border-top: 1px solid #a7a7a780;
  }
`

export const Button = styled.button`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  padding: 22px 14px 14px 30px;

  background: none;
  border: 0;

  opacity: ${({ theme }) => (theme.isDark ? 0.6 : 0.8)};

  .lock {
    color: #a7a7a7;

    flex-shrink: 0;

    width: 15px;
    height: 15px;

    margin-top: 2px;
    margin-right: 8px;
  }

  .group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 6px;

    max-width: 246px;

    .title {
      display: flex;
      align-items: flex-start;
      gap: 4px;

      color: ${({ theme }) => (theme.isDark ? '#fff' : '#4a4a4a')};
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 17px;

      text-align: start;

      .name {
        word-break: break-word;
      }
    }

    .duration {
      color: ${({ theme }) => (theme.isDark ? '#C6C6C6' : '#808080')};

      font-size: 10px;
      font-style: normal;
      font-weight: 600;
      line-height: 17px;
    }
  }

  .arrow {
    width: 20px;
    height: 20px;

    color: #4b4b4b;

    flex-shrink: 0;

    margin-left: auto;

    transition: all 0.3s ease;
  }
`
